import React, { useState, useEffect, useCallback } from 'react';
import { fleetService } from '../services/fleetService';
import { toast } from 'react-toastify';
import BusMascot from '../components/BusMascot';
import MaintenanceTab from './MaintenanceTab';
import './Fleet.css';
import './MaintenanceTab.css';

// SVG Icons for professional look
const Icons = {
  bus: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 6v6M15 6v6M2 12h19.6M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H6c-1.1 0-2.1.8-2.4 1.8l-1.4 5c-.1.4-.2.8-.2 1.2 0 .4.1.8.2 1.2.3 1.1.8 2.8.8 2.8h3"/>
      <circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>
    </svg>
  ),
  check: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  ),
  route: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="6" cy="19" r="3"/><path d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15"/>
      <circle cx="18" cy="5" r="3"/>
    </svg>
  ),
  wrench: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
    </svg>
  ),
  clipboard: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
      <path d="M12 11h4M12 16h4M8 11h.01M8 16h.01"/>
    </svg>
  ),
  alert: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
      <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  ),
  eye: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
    </svg>
  ),
  edit: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
    </svg>
  ),
  clock: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
  ),
  fleet: (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="3" width="15" height="13" rx="2" ry="2"/><path d="M16 8h4l3 5v4h-7V8z"/>
      <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
    </svg>
  ),
  plus: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
    </svg>
  ),
  upload: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
      <polyline points="17 8 12 3 7 8"/>
      <line x1="12" y1="3" x2="12" y2="15"/>
    </svg>
  ),
  shield: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  ),
  trash: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6"/>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
    </svg>
  ),
  download: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
      <polyline points="7 10 12 15 17 10"/>
      <line x1="12" y1="15" x2="12" y2="3"/>
    </svg>
  ),
  file: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <line x1="16" y1="13" x2="8" y2="13"/>
      <line x1="16" y1="17" x2="8" y2="17"/>
    </svg>
  )
};

// Transform backend compliance response to frontend expected shape
const transformComplianceData = (data) => {
  if (!data) return data;

  const rawSummary = data.summary || {};

  const sumLevel = (level) => {
    const obj = rawSummary[level];
    if (!obj || typeof obj !== 'object') return obj || 0;
    return (obj.inspection || 0) + (obj.registration || 0) + (obj.insurance || 0);
  };

  const transformedSummary = {
    total_vehicles: rawSummary.total_vehicles || 0,
    expired: sumLevel('expired'),
    critical: sumLevel('critical'),
    warning: sumLevel('warning'),
    caution: sumLevel('caution'),
    ok: sumLevel('ok'),
    unknown: sumLevel('unknown')
  };

  const alertLevels = ['expired', 'critical', 'warning', 'caution'];
  const types = [
    { key: 'inspection', statusField: 'inspection_status', expiryField: 'inspection_expiry', daysField: 'inspection_days_remaining' },
    { key: 'registration', statusField: 'registration_status', expiryField: 'registration_expiry', daysField: 'registration_days_remaining' },
    { key: 'insurance', statusField: 'insurance_status', expiryField: 'insurance_expiry', daysField: 'insurance_days_remaining' }
  ];

  const transformVehicle = (v) => {
    const alerts = [];
    types.forEach(t => {
      const level = v[t.statusField];
      if (alertLevels.includes(level)) {
        alerts.push({
          alert_level: level,
          type: t.key,
          expiry_date: v[t.expiryField],
          days_remaining: v[t.daysField]
        });
      }
    });
    return { ...v, alerts };
  };

  const alertVehicles = (data.alert_vehicles || []).map(transformVehicle);

  return {
    summary: transformedSummary,
    total_alerts: data.total_alerts,
    vehicles: (data.vehicles || []).map(transformVehicle),
    alert_vehicles: alertVehicles
  };
};

const Fleet = () => {
  const [vehicles, setVehicles] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ status: '', reason: '', make: '', year: '', search: '' });
  const [filterOptions, setFilterOptions] = useState({ makes: [], years: [] });
  
  // Main tab: 'vehicles', 'compliance', or 'maintenance'
  const [activeMainTab, setActiveMainTab] = useState('vehicles');
  
  // Compliance data
  const [complianceAlerts, setComplianceAlerts] = useState(null);
  const [complianceLoading, setComplianceLoading] = useState(false);
  
  // Modals
  const [showAddModal, setShowAddModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showDisposalModal, setShowDisposalModal] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchVehicles();
  }, [filters]);

  // Load compliance data when tab switches
  useEffect(() => {
    if (activeMainTab === 'compliance' && !complianceAlerts) {
      fetchComplianceAlerts();
    }
  }, [activeMainTab]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [vehiclesData, summaryData] = await Promise.all([
        fleetService.getAll(filters),
        fleetService.getStatusSummary()
      ]);
      setVehicles(vehiclesData.vehicles || []);
      setFilterOptions(vehiclesData.filters || { makes: [], years: [] });
      setSummary(summaryData.summary);
    } catch (err) {
      toast.error('Failed to load fleet data');
    } finally {
      setLoading(false);
    }
  };

  const fetchVehicles = async () => {
    try {
      const data = await fleetService.getAll(filters);
      setVehicles(data.vehicles || []);
    } catch (err) {
      toast.error('Failed to load vehicles');
    }
  };

  const fetchComplianceAlerts = async () => {
    try {
      setComplianceLoading(true);
      const data = await fleetService.getComplianceAlerts();
      setComplianceAlerts(transformComplianceData(data));
    } catch (err) {
      toast.error('Failed to load compliance alerts');
    } finally {
      setComplianceLoading(false);
    }
  };

  const handleFilterClick = (status, reason = '') => {
    setFilters(prev => ({
      ...prev,
      status: prev.status === status && prev.reason === reason ? '' : status,
      reason: reason
    }));
  };

  const getStatusBadge = (vehicle) => {
    if (vehicle.status === 'retired') {
      return <span className="status-badge retired"><span className="status-dot"></span>Retired</span>;
    }
    if (vehicle.status === 'available' || vehicle.status === 'active') {
      return <span className="status-badge available"><span className="status-dot"></span>Available</span>;
    }
    if (vehicle.status === 'in_service') {
      return <span className="status-badge in_service"><span className="status-dot"></span>In Service</span>;
    }
    if (vehicle.status === 'out_of_service') {
      const reason = vehicle.out_of_service_reason || 'other';
      const labels = {
        mechanical: 'Mechanical',
        compliance: 'Compliance',
        accident: 'Accident',
        other: 'Out'
      };
      return <span className={`status-badge out-${reason}`}><span className="status-dot"></span>{labels[reason]}</span>;
    }
    return <span className="status-badge">{vehicle.status}</span>;
  };

  const openStatusModal = (vehicle) => {
    setSelectedVehicle(vehicle);
    setShowStatusModal(true);
  };

  const openDetailModal = async (vehicle) => {
    try {
      const fullData = await fleetService.getById(vehicle.id);
      setSelectedVehicle(fullData);
      setShowDetailModal(true);
    } catch (err) {
      toast.error('Failed to load vehicle details');
    }
  };

  const openDisposalModal = (vehicle) => {
    setSelectedVehicle(vehicle);
    setShowDisposalModal(true);
  };

  // Count total compliance alerts for badge
  const complianceAlertCount = complianceAlerts
    ? (complianceAlerts.summary?.expired || 0) + (complianceAlerts.summary?.critical || 0)
    : 0;

  return (
    <div className="fleet-container">
      {/* Header */}
      <div className="fleet-header">
        <h1><span className="header-icon">{Icons.fleet}</span> Fleet Management</h1>
        <div className="fleet-header-actions">
          <button className="btn-secondary" onClick={() => setShowImportModal(true)}>
            {Icons.upload} Import Excel
          </button>
          <button className="btn-primary" onClick={() => setShowAddModal(true)}>
            {Icons.plus} Add Vehicle
          </button>
        </div>
      </div>

      {/* Main Tab Switcher */}
      <div className="main-tabs">
        <button
          className={`main-tab ${activeMainTab === 'vehicles' ? 'active' : ''}`}
          onClick={() => setActiveMainTab('vehicles')}
        >
          {Icons.fleet} Vehicles
        </button>
        <button
          className={`main-tab ${activeMainTab === 'compliance' ? 'active' : ''}`}
          onClick={() => setActiveMainTab('compliance')}
        >
          {Icons.shield} Compliance
          {complianceAlertCount > 0 && (
            <span className="tab-badge">{complianceAlertCount}</span>
          )}
        </button>
        <button
          className={`main-tab ${activeMainTab === 'maintenance' ? 'active' : ''}`}
          onClick={() => setActiveMainTab('maintenance')}
        >
          {Icons.wrench} Maintenance
        </button>
      </div>

      {/* === VEHICLES TAB === */}
      {activeMainTab === 'vehicles' && (
        <>
          {/* Stats Cards */}
          {summary && (
            <div className="fleet-stats">
              <div
                className={`stat-card ${filters.status === '' ? 'active' : ''}`}
                onClick={() => handleFilterClick('')}
                style={{ boxShadow: '0 0 25px rgba(212,169,78,0.35), 0 0 50px rgba(212,169,78,0.15), 0 0 80px rgba(212,169,78,0.05)' }}
              >
                <div className="stat-icon total">{Icons.fleet}</div>
                <div className="stat-value">{summary.total}</div>
                <div className="stat-label">Total Fleet</div>
              </div>
              <div
                className={`stat-card ${filters.status === 'available' ? 'active' : ''}`}
                onClick={() => handleFilterClick('available')}
                style={{ boxShadow: '0 0 25px rgba(212,169,78,0.35), 0 0 50px rgba(212,169,78,0.15), 0 0 80px rgba(212,169,78,0.05)' }}
              >
                <div className="stat-icon available">{Icons.check}</div>
                <div className="stat-value">{summary.available}</div>
                <div className="stat-label">Available</div>
              </div>
              <div
                className={`stat-card ${filters.status === 'in_service' ? 'active' : ''}`}
                onClick={() => handleFilterClick('in_service')}
                style={{ boxShadow: '0 0 25px rgba(212,169,78,0.35), 0 0 50px rgba(212,169,78,0.15), 0 0 80px rgba(212,169,78,0.05)' }}
              >
                <div className="stat-icon in-service">{Icons.route}</div>
                <div className="stat-value">{summary.in_service}</div>
                <div className="stat-label">In Service</div>
              </div>
              <div
                className={`stat-card ${filters.reason === 'mechanical' ? 'active' : ''}`}
                onClick={() => handleFilterClick('out_of_service', 'mechanical')}
                style={{ boxShadow: '0 0 25px rgba(212,169,78,0.35), 0 0 50px rgba(212,169,78,0.15), 0 0 80px rgba(212,169,78,0.05)' }}
              >
                <div className="stat-icon mechanical">{Icons.wrench}</div>
                <div className="stat-value">{summary.out_mechanical}</div>
                <div className="stat-label">Mechanical</div>
              </div>
              <div
                className={`stat-card ${filters.reason === 'compliance' ? 'active' : ''}`}
                onClick={() => handleFilterClick('out_of_service', 'compliance')}
                style={{ boxShadow: '0 0 25px rgba(212,169,78,0.35), 0 0 50px rgba(212,169,78,0.15), 0 0 80px rgba(212,169,78,0.05)' }}
              >
                <div className="stat-icon compliance">{Icons.clipboard}</div>
                <div className="stat-value">{summary.out_compliance}</div>
                <div className="stat-label">Compliance</div>
              </div>
              <div
                className={`stat-card ${filters.reason === 'accident' ? 'active' : ''}`}
                onClick={() => handleFilterClick('out_of_service', 'accident')}
                style={{ boxShadow: '0 0 25px rgba(212,169,78,0.35), 0 0 50px rgba(212,169,78,0.15), 0 0 80px rgba(212,169,78,0.05)' }}
              >
                <div className="stat-icon accident">{Icons.alert}</div>
                <div className="stat-value">{summary.out_accident}</div>
                <div className="stat-label">Accident</div>
              </div>
            </div>
          )}

          {/* Filters */}
          <div className="fleet-filters">
            <input
              type="text"
              placeholder="Search by bus #, VIN, or plate..."
              className="search-input"
              value={filters.search}
              onChange={(e) => setFilters(prev => ({ ...prev, search: e.target.value }))}
            />
            <select 
              className="filter-select"
              value={filters.make}
              onChange={(e) => setFilters(prev => ({ ...prev, make: e.target.value }))}
            >
              <option value="">All Makes</option>
              {filterOptions.makes.map(make => (
                <option key={make} value={make}>{make}</option>
              ))}
            </select>
            <select 
              className="filter-select"
              value={filters.year}
              onChange={(e) => setFilters(prev => ({ ...prev, year: e.target.value }))}
            >
              <option value="">All Years</option>
              {filterOptions.years.map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
            {(filters.status || filters.reason || filters.make || filters.year || filters.search) && (
              <button 
                className="btn-secondary"
                onClick={() => setFilters({ status: '', reason: '', make: '', year: '', search: '' })}
              >
                Clear Filters
              </button>
            )}
          </div>

          {/* Vehicle Table */}
          {loading ? (
            <div className="loading-container">
              <BusMascot size={60} animated />
              <p>Loading fleet...</p>
            </div>
          ) : vehicles.length === 0 ? (
            <div className="empty-state">
              <div className="empty-state-icon">{Icons.fleet}</div>
              <h3>No vehicles found</h3>
              <p>Try adjusting your filters or add a new vehicle</p>
            </div>
          ) : (
            <div className="fleet-table-container" style={{ boxShadow: '0 0 15px rgba(212,169,78,0.12), 0 0 30px rgba(212,169,78,0.06)' }}>
              <table className="fleet-table">
                <thead>
                  <tr>
                    <th>Bus #</th>
                    <th>Vehicle</th>
                    <th>Status</th>
                    <th>Route</th>
                    <th>Days Out</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {vehicles.map(vehicle => (
                    <tr 
                      key={vehicle.id} 
                      className={`${vehicle.status === 'out_of_service' ? 'out-of-service' : ''} ${vehicle.status === 'retired' ? 'retired-row' : ''}`}
                    >
                      <td>
                        <span className="bus-number">
                          <span className="bus-icon">{Icons.bus}</span>
                          {vehicle.bus_number}
                        </span>
                      </td>
                      <td>
                        <div className="vehicle-info">
                          <span className="vehicle-make-model">
                            {vehicle.make || 'Unknown'} {vehicle.model || ''} {vehicle.year || ''}
                          </span>
                          {vehicle.vin && (
                            <span className="vehicle-vin">VIN: {vehicle.vin}</span>
                          )}
                        </div>
                      </td>
                      <td>{getStatusBadge(vehicle)}</td>
                      <td>
                        {vehicle.route_number ? (
                          <span>{vehicle.route_number}</span>
                        ) : (
                          <span style={{ color: '#6B6B6B' }}>—</span>
                        )}
                      </td>
                      <td>
                        {vehicle.days_out ? (
                          <span className={`days-out ${vehicle.days_out > 14 ? 'critical' : vehicle.days_out > 7 ? 'warning' : ''}`}>
                            {Icons.clock} {Math.round(vehicle.days_out)} days
                          </span>
                        ) : (
                          <span style={{ color: '#6B6B6B' }}>—</span>
                        )}
                      </td>
                      <td>
                        <div className="action-buttons">
                          <button 
                            className="btn-icon view" 
                            title="View Details"
                            onClick={() => openDetailModal(vehicle)}
                          >
                            {Icons.eye}
                          </button>
                          <button 
                            className="btn-icon status" 
                            title="Change Status"
                            onClick={() => openStatusModal(vehicle)}
                          >
                            {Icons.edit}
                          </button>
                          {vehicle.status !== 'retired' && (
                            <button 
                              className="btn-icon dispose" 
                              title="Dispose Vehicle"
                              onClick={() => openDisposalModal(vehicle)}
                            >
                              {Icons.trash}
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {/* === COMPLIANCE TAB === */}
      {activeMainTab === 'compliance' && (
        <ComplianceTab
          alerts={complianceAlerts}
          loading={complianceLoading}
          onRefresh={fetchComplianceAlerts}
        />
      )}

      {/* === MAINTENANCE TAB === */}
      {activeMainTab === 'maintenance' && (
        <MaintenanceTab vehicles={vehicles} />
      )}

      {/* Add Vehicle Modal */}
      {showAddModal && (
        <AddVehicleModal 
          onClose={() => setShowAddModal(false)}
          onSave={() => {
            setShowAddModal(false);
            fetchData();
          }}
        />
      )}

      {/* Status Change Modal */}
      {showStatusModal && selectedVehicle && (
        <StatusChangeModal 
          vehicle={selectedVehicle}
          onClose={() => {
            setShowStatusModal(false);
            setSelectedVehicle(null);
          }}
          onSave={() => {
            setShowStatusModal(false);
            setSelectedVehicle(null);
            fetchData();
          }}
        />
      )}

      {/* Vehicle Detail Modal */}
      {showDetailModal && selectedVehicle && (
        <VehicleDetailModal 
          vehicle={selectedVehicle}
          onClose={() => {
            setShowDetailModal(false);
            setSelectedVehicle(null);
          }}
          onStatusChange={() => {
            setShowDetailModal(false);
            openStatusModal(selectedVehicle);
          }}
          onDispose={() => {
            setShowDetailModal(false);
            openDisposalModal(selectedVehicle);
          }}
        />
      )}

      {/* Import Modal */}
      {showImportModal && (
        <ImportModal
          onClose={() => setShowImportModal(false)}
          onComplete={() => {
            setShowImportModal(false);
            fetchData();
            // Refresh compliance if already loaded
            if (complianceAlerts) fetchComplianceAlerts();
          }}
        />
      )}

      {/* Disposal Modal */}
      {showDisposalModal && selectedVehicle && (
        <DisposalModal
          vehicle={selectedVehicle}
          onClose={() => {
            setShowDisposalModal(false);
            setSelectedVehicle(null);
          }}
          onComplete={() => {
            setShowDisposalModal(false);
            setSelectedVehicle(null);
            fetchData();
          }}
        />
      )}
    </div>
  );
};


// ===========================
// COMPLIANCE TAB COMPONENT
// ===========================
const ComplianceTab = ({ alerts, loading, onRefresh }) => {
  const [complianceFilter, setComplianceFilter] = useState('all');
  const [complianceSearch, setComplianceSearch] = useState('');

  if (loading) {
    return (
      <div className="loading-container">
        <BusMascot size={60} animated />
        <p>Loading compliance data...</p>
      </div>
    );
  }

  if (!alerts || !alerts.alert_vehicles) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">{Icons.shield}</div>
        <h3>No compliance data available</h3>
        <p>Import vehicle data with expiration dates to track compliance</p>
      </div>
    );
  }

  const { summary, alert_vehicles } = alerts;

  // Filter vehicles
  const filteredVehicles = alert_vehicles.filter(v => {
    // Status filter
    if (complianceFilter !== 'all') {
      const hasMatchingAlert = v.alerts?.some(a => a.alert_level === complianceFilter);
      if (!hasMatchingAlert) return false;
    }
    // Search filter
    if (complianceSearch) {
      const search = complianceSearch.toLowerCase();
      return (
        v.bus_number?.toLowerCase().includes(search) ||
        v.make?.toLowerCase().includes(search) ||
        v.vin?.toLowerCase().includes(search)
      );
    }
    return true;
  });

  const getAlertBadge = (level) => {
    const config = {
      expired: { label: 'Expired', className: 'alert-badge-expired' },
      critical: { label: 'Critical', className: 'alert-badge-critical' },
      warning: { label: 'Warning', className: 'alert-badge-warning' },
      caution: { label: 'Caution', className: 'alert-badge-caution' }
    };
    const c = config[level] || config.caution;
    return <span className={`alert-badge ${c.className}`}>{c.label}</span>;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="compliance-tab">
      {/* Summary Cards */}
      <div className="compliance-cards">
        <div
          className={`compliance-card expired ${complianceFilter === 'expired' ? 'active' : ''}`}
          onClick={() => setComplianceFilter(complianceFilter === 'expired' ? 'all' : 'expired')}
          style={{ boxShadow: '0 0 25px rgba(212,169,78,0.35), 0 0 50px rgba(212,169,78,0.15), 0 0 80px rgba(212,169,78,0.05)' }}
        >
          <div className="compliance-card-value">{summary?.expired || 0}</div>
          <div className="compliance-card-label">Expired</div>
          <div className="compliance-card-desc">Past due</div>
        </div>
        <div
          className={`compliance-card critical ${complianceFilter === 'critical' ? 'active' : ''}`}
          onClick={() => setComplianceFilter(complianceFilter === 'critical' ? 'all' : 'critical')}
          style={{ boxShadow: '0 0 25px rgba(212,169,78,0.35), 0 0 50px rgba(212,169,78,0.15), 0 0 80px rgba(212,169,78,0.05)' }}
        >
          <div className="compliance-card-value">{summary?.critical || 0}</div>
          <div className="compliance-card-label">Critical</div>
          <div className="compliance-card-desc">Within 15 days</div>
        </div>
        <div
          className={`compliance-card warning ${complianceFilter === 'warning' ? 'active' : ''}`}
          onClick={() => setComplianceFilter(complianceFilter === 'warning' ? 'all' : 'warning')}
          style={{ boxShadow: '0 0 25px rgba(212,169,78,0.35), 0 0 50px rgba(212,169,78,0.15), 0 0 80px rgba(212,169,78,0.05)' }}
        >
          <div className="compliance-card-value">{summary?.warning || 0}</div>
          <div className="compliance-card-label">Warning</div>
          <div className="compliance-card-desc">Within 30 days</div>
        </div>
        <div
          className={`compliance-card caution ${complianceFilter === 'caution' ? 'active' : ''}`}
          onClick={() => setComplianceFilter(complianceFilter === 'caution' ? 'all' : 'caution')}
          style={{ boxShadow: '0 0 25px rgba(212,169,78,0.35), 0 0 50px rgba(212,169,78,0.15), 0 0 80px rgba(212,169,78,0.05)' }}
        >
          <div className="compliance-card-value">{summary?.caution || 0}</div>
          <div className="compliance-card-label">Caution</div>
          <div className="compliance-card-desc">Within 60 days</div>
        </div>
      </div>

      {/* Compliance Filters */}
      <div className="fleet-filters">
        <input
          type="text"
          placeholder="Search by bus #, make, or VIN..."
          className="search-input"
          value={complianceSearch}
          onChange={(e) => setComplianceSearch(e.target.value)}
        />
        <button className="btn-secondary" onClick={onRefresh}>
          Refresh
        </button>
      </div>

      {/* Compliance Table */}
      {filteredVehicles.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">{Icons.check}</div>
          <h3>All clear!</h3>
          <p>No vehicles match the selected compliance filter</p>
        </div>
      ) : (
        <div className="fleet-table-container">
          <table className="fleet-table compliance-table">
            <thead>
              <tr>
                <th>Bus #</th>
                <th>Vehicle</th>
                <th>Alert</th>
                <th>Type</th>
                <th>Expiry Date</th>
                <th>Days Left</th>
              </tr>
            </thead>
            <tbody>
              {filteredVehicles.map(vehicle => (
                vehicle.alerts?.map((alert, idx) => (
                  <tr key={`${vehicle.id}-${idx}`} className={`compliance-row-${alert.alert_level}`}>
                    {idx === 0 && (
                      <>
                        <td rowSpan={vehicle.alerts.length}>
                          <span className="bus-number">
                            <span className="bus-icon">{Icons.bus}</span>
                            {vehicle.bus_number}
                          </span>
                        </td>
                        <td rowSpan={vehicle.alerts.length}>
                          <div className="vehicle-info">
                            <span className="vehicle-make-model">
                              {vehicle.make || ''} {vehicle.model || ''} {vehicle.year || ''}
                            </span>
                          </div>
                        </td>
                      </>
                    )}
                    <td>{getAlertBadge(alert.alert_level)}</td>
                    <td className="compliance-type">{alert.type?.replace(/_/g, ' ')}</td>
                    <td>{formatDate(alert.expiry_date)}</td>
                    <td>
                      <span className={`days-remaining ${alert.alert_level}`}>
                        {alert.days_remaining != null ? (
                          alert.days_remaining < 0 
                            ? `${Math.abs(alert.days_remaining)} days overdue`
                            : `${alert.days_remaining} days`
                        ) : '—'}
                      </span>
                    </td>
                  </tr>
                ))
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};


// ===========================
// IMPORT MODAL COMPONENT
// ===========================
const ImportModal = ({ onClose, onComplete }) => {
  const [file, setFile] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [results, setResults] = useState(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      validateAndSetFile(e.dataTransfer.files[0]);
    }
  };

  const handleFileSelect = (e) => {
    if (e.target.files && e.target.files[0]) {
      validateAndSetFile(e.target.files[0]);
    }
  };

  const validateAndSetFile = (f) => {
    const validTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel'
    ];
    if (!validTypes.includes(f.type) && !f.name.match(/\.xlsx?$/i)) {
      toast.error('Please upload an Excel file (.xlsx or .xls)');
      return;
    }
    setFile(f);
    setResults(null);
  };

  const handleUpload = async () => {
    if (!file) return;
    try {
      setUploading(true);
      const data = await fleetService.importExcel(file);
      setResults(data);
      toast.success(`Import complete: ${data.created || 0} created, ${data.updated || 0} updated`);
    } catch (err) {
      toast.error(err.message || 'Import failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{Icons.upload} Import Fleet Data</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="modal-body">
          {!results ? (
            <>
              {/* Drop Zone */}
              <div
                className={`import-drop-zone ${dragActive ? 'drag-active' : ''} ${file ? 'has-file' : ''}`}
                onDragEnter={handleDrag}
                onDragOver={handleDrag}
                onDragLeave={handleDrag}
                onDrop={handleDrop}
                onClick={() => document.getElementById('import-file-input').click()}
              >
                <input
                  id="import-file-input"
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={handleFileSelect}
                  style={{ display: 'none' }}
                />
                {file ? (
                  <div className="import-file-info">
                    <div className="import-file-icon">{Icons.file}</div>
                    <div className="import-file-name">{file.name}</div>
                    <div className="import-file-size">{(file.size / 1024).toFixed(1)} KB</div>
                    <button
                      className="btn-secondary"
                      style={{ marginTop: '0.75rem' }}
                      onClick={(e) => { e.stopPropagation(); setFile(null); }}
                    >
                      Remove
                    </button>
                  </div>
                ) : (
                  <div className="import-drop-content">
                    <div className="import-drop-icon">{Icons.upload}</div>
                    <p className="import-drop-text">Drag & drop your Excel file here</p>
                    <p className="import-drop-hint">or click to browse</p>
                    <p className="import-drop-formats">Supports .xlsx and .xls</p>
                  </div>
                )}
              </div>

              {/* Column Mapping Info */}
              <div className="import-info">
                <h4>Expected Columns</h4>
                <p>The Excel file should include columns like: Bus Number, VIN, Make, Model, Year, License Plate, Capacity, Fuel Type, Inspection Expiry, Registration Expiry, Insurance Expiry, etc.</p>
                <p style={{ fontSize: '0.8rem', color: '#6B6B6B', marginTop: '0.5rem' }}>
                  Existing vehicles (matched by Bus Number or VIN) will be updated. New vehicles will be created.
                </p>
              </div>
            </>
          ) : (
            /* Import Results */
            <div className="import-results">
              <h3 className="import-results-title">Import Complete</h3>
              <div className="import-results-grid">
                <div className="import-result-card created">
                  <div className="import-result-value">{results.created || 0}</div>
                  <div className="import-result-label">Created</div>
                </div>
                <div className="import-result-card updated">
                  <div className="import-result-value">{results.updated || 0}</div>
                  <div className="import-result-label">Updated</div>
                </div>
                <div className="import-result-card skipped">
                  <div className="import-result-value">{results.skipped || 0}</div>
                  <div className="import-result-label">Skipped</div>
                </div>
                <div className="import-result-card errors">
                  <div className="import-result-value">{results.errors?.length || 0}</div>
                  <div className="import-result-label">Errors</div>
                </div>
              </div>

              {results.errors && results.errors.length > 0 && (
                <div className="import-errors">
                  <h4>Errors</h4>
                  <div className="import-error-list">
                    {results.errors.map((err, idx) => (
                      <div key={idx} className="import-error-item">
                        <strong>Row {err.row}:</strong> {err.message}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="modal-footer">
          {!results ? (
            <>
              <button className="btn-secondary" onClick={onClose}>Cancel</button>
              <button
                className="btn-primary"
                onClick={handleUpload}
                disabled={!file || uploading}
              >
                {uploading ? 'Importing...' : 'Import'}
              </button>
            </>
          ) : (
            <button className="btn-primary" onClick={onComplete}>Done</button>
          )}
        </div>
      </div>
    </div>
  );
};


// ===========================
// DISPOSAL MODAL COMPONENT
// ===========================
const DisposalModal = ({ vehicle, onClose, onComplete }) => {
  const [disposalType, setDisposalType] = useState('');
  const [disposalNotes, setDisposalNotes] = useState('');
  const [disposalDate, setDisposalDate] = useState(new Date().toISOString().split('T')[0]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [saving, setSaving] = useState(false);

  const disposalTypes = [
    { value: 'donated', label: 'Donated', icon: '🎁', desc: 'Given to charity or organization' },
    { value: 'sold', label: 'Sold', icon: '💰', desc: 'Sold to buyer' },
    { value: 'traded', label: 'Traded', icon: '🔄', desc: 'Traded in for another vehicle' },
    { value: 'gifted', label: 'Gifted', icon: '🤝', desc: 'Given to individual' },
    { value: 'totaled', label: 'Totaled', icon: '💥', desc: 'Written off as total loss' }
  ];

  const handleDispose = async () => {
    try {
      setSaving(true);
      await fleetService.disposeVehicle(vehicle.id, {
        disposal_type: disposalType,
        disposal_notes: disposalNotes,
        disposal_date: disposalDate
      });
      toast.success(`${vehicle.bus_number} has been retired (${disposalType})`);
      onComplete();
    } catch (err) {
      toast.error(err.message || 'Failed to dispose vehicle');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Dispose Vehicle - {vehicle.bus_number}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="modal-body">
          {!showConfirm ? (
            <>
              <p style={{ color: '#A0A0A0', marginBottom: '1.25rem' }}>
                Select how this vehicle is being disposed. This will retire it from the active fleet.
              </p>

              {/* Disposal Type Grid */}
              <div className="disposal-grid">
                {disposalTypes.map(type => (
                  <div
                    key={type.value}
                    className={`disposal-option ${disposalType === type.value ? 'selected' : ''}`}
                    onClick={() => setDisposalType(type.value)}
                  >
                    <div className="disposal-option-icon">{type.icon}</div>
                    <div className="disposal-option-label">{type.label}</div>
                    <div className="disposal-option-desc">{type.desc}</div>
                  </div>
                ))}
              </div>

              <div className="form-group" style={{ marginTop: '1.25rem' }}>
                <label>Disposal Date</label>
                <input
                  type="date"
                  value={disposalDate}
                  onChange={(e) => setDisposalDate(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Notes (optional)</label>
                <textarea
                  rows={3}
                  value={disposalNotes}
                  onChange={(e) => setDisposalNotes(e.target.value)}
                  placeholder="Buyer info, sale price, reason, etc."
                />
              </div>
            </>
          ) : (
            /* Confirmation Screen */
            <div className="disposal-confirm">
              <div className="disposal-confirm-icon">⚠️</div>
              <h3>Confirm Vehicle Disposal</h3>
              <p>
                You are about to retire <strong>{vehicle.bus_number}</strong> ({vehicle.make} {vehicle.model} {vehicle.year}).
              </p>
              <div className="disposal-confirm-details">
                <div><strong>Type:</strong> {disposalType}</div>
                <div><strong>Date:</strong> {disposalDate}</div>
                {disposalNotes && <div><strong>Notes:</strong> {disposalNotes}</div>}
              </div>
              <p className="disposal-confirm-warning">
                This action will change the vehicle status to "retired". The vehicle will no longer appear in the active fleet.
              </p>
            </div>
          )}
        </div>

        <div className="modal-footer">
          {!showConfirm ? (
            <>
              <button className="btn-secondary" onClick={onClose}>Cancel</button>
              <button
                className="btn-danger"
                onClick={() => setShowConfirm(true)}
                disabled={!disposalType}
              >
                Continue
              </button>
            </>
          ) : (
            <>
              <button className="btn-secondary" onClick={() => setShowConfirm(false)}>Back</button>
              <button
                className="btn-danger"
                onClick={handleDispose}
                disabled={saving}
              >
                {saving ? 'Processing...' : 'Confirm Disposal'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};


// ===========================
// ADD VEHICLE MODAL
// ===========================
const AddVehicleModal = ({ onClose, onSave }) => {
  const [formData, setFormData] = useState({
    bus_number: '',
    make: '',
    model: '',
    year: '',
    vin: '',
    license_plate: '',
    capacity: 44,
    vehicle_type: 'school_bus',
    fuel_type: 'gasoline',
    geotab_device_id: '',
    geotab_serial_number: ''
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.bus_number) {
      toast.error('Bus number is required');
      return;
    }

    try {
      setSaving(true);
      await fleetService.create(formData);
      toast.success('Vehicle added successfully');
      onSave();
    } catch (err) {
      toast.error(err.message || 'Failed to add vehicle');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add New Vehicle</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-row">
              <div className="form-group">
                <label>Bus Number *</label>
                <input
                  type="text"
                  value={formData.bus_number}
                  onChange={(e) => setFormData({ ...formData, bus_number: e.target.value })}
                  placeholder="e.g., GV0001"
                  required
                />
              </div>
              <div className="form-group">
                <label>Vehicle Type</label>
                <select
                  value={formData.vehicle_type}
                  onChange={(e) => setFormData({ ...formData, vehicle_type: e.target.value })}
                >
                  <option value="school_bus">School Bus</option>
                  <option value="mini_bus">Mini Bus</option>
                  <option value="van">Van</option>
                  <option value="other">Other</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Make</label>
                <input
                  type="text"
                  value={formData.make}
                  onChange={(e) => setFormData({ ...formData, make: e.target.value })}
                  placeholder="e.g., Chevrolet"
                />
              </div>
              <div className="form-group">
                <label>Model</label>
                <input
                  type="text"
                  value={formData.model}
                  onChange={(e) => setFormData({ ...formData, model: e.target.value })}
                  placeholder="e.g., Express"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Year</label>
                <input
                  type="number"
                  value={formData.year}
                  onChange={(e) => setFormData({ ...formData, year: e.target.value })}
                  placeholder="e.g., 2024"
                />
              </div>
              <div className="form-group">
                <label>Capacity</label>
                <input
                  type="number"
                  value={formData.capacity}
                  onChange={(e) => setFormData({ ...formData, capacity: e.target.value })}
                />
              </div>
            </div>

            <div className="form-group">
              <label>VIN</label>
              <input
                type="text"
                value={formData.vin}
                onChange={(e) => setFormData({ ...formData, vin: e.target.value })}
                placeholder="Vehicle Identification Number"
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>License Plate</label>
                <input
                  type="text"
                  value={formData.license_plate}
                  onChange={(e) => setFormData({ ...formData, license_plate: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Fuel Type</label>
                <select
                  value={formData.fuel_type}
                  onChange={(e) => setFormData({ ...formData, fuel_type: e.target.value })}
                >
                  <option value="gasoline">Gasoline</option>
                  <option value="diesel">Diesel</option>
                  <option value="electric">Electric</option>
                  <option value="hybrid">Hybrid</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Geotab Device ID</label>
                <input
                  type="text"
                  value={formData.geotab_device_id}
                  onChange={(e) => setFormData({ ...formData, geotab_device_id: e.target.value })}
                  placeholder="Optional"
                />
              </div>
              <div className="form-group">
                <label>Geotab Serial</label>
                <input
                  type="text"
                  value={formData.geotab_serial_number}
                  onChange={(e) => setFormData({ ...formData, geotab_serial_number: e.target.value })}
                  placeholder="Optional"
                />
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? 'Saving...' : 'Add Vehicle'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};


// ===========================
// STATUS CHANGE MODAL
// ===========================
const StatusChangeModal = ({ vehicle, onClose, onSave }) => {
  const normalizedStatus = vehicle.status === 'active' ? 'available' : vehicle.status;
  const [status, setStatus] = useState(normalizedStatus);
  const [reason, setReason] = useState(vehicle.out_of_service_reason || '');
  const [reasonDetail, setReasonDetail] = useState(vehicle.out_of_service_notes || '');
  const [expectedReturn, setExpectedReturn] = useState(vehicle.expected_return_date || '');
  const [resolutionNotes, setResolutionNotes] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    try {
      setSaving(true);
      
      if ((vehicle.status === 'out_of_service') && status === 'available') {
        await fleetService.returnToService(vehicle.id, { resolution_notes: resolutionNotes });
        toast.success('Vehicle returned to service');
      } else {
        await fleetService.changeStatus(vehicle.id, {
          status,
          reason: status === 'out_of_service' ? reason : null,
          reason_detail: reasonDetail,
          expected_return_date: expectedReturn || null
        });
        toast.success('Status updated successfully');
      }
      
      onSave();
    } catch (err) {
      toast.error(err.message || 'Failed to update status');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Change Status - {vehicle.bus_number}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        
        <div className="modal-body">
          <div className="form-group">
            <label>Current Status</label>
            <p style={{ fontWeight: 500, color: '#E0E0E0' }}>
              {vehicle.status === 'out_of_service' 
                ? `Out of Service - ${vehicle.out_of_service_reason || 'Unknown'}`
                : (vehicle.status === 'active' ? 'Available' : vehicle.status?.replace('_', ' '))
              }
            </p>
          </div>

          <div className="form-group">
            <label>New Status</label>
            <div className="status-options">
              <label className={`status-option ${status === 'available' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="status"
                  value="available"
                  checked={status === 'available'}
                  onChange={(e) => setStatus(e.target.value)}
                />
                <div className="status-option-icon green">{Icons.check}</div>
                <div className="status-option-text">
                  <strong>Available</strong>
                  <span>Ready to be assigned</span>
                </div>
              </label>
              <label className={`status-option ${status === 'in_service' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="status"
                  value="in_service"
                  checked={status === 'in_service'}
                  onChange={(e) => setStatus(e.target.value)}
                />
                <div className="status-option-icon blue">{Icons.route}</div>
                <div className="status-option-text">
                  <strong>In Service</strong>
                  <span>Currently on a route</span>
                </div>
              </label>
              <label className={`status-option ${status === 'out_of_service' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="status"
                  value="out_of_service"
                  checked={status === 'out_of_service'}
                  onChange={(e) => setStatus(e.target.value)}
                />
                <div className="status-option-icon red">{Icons.alert}</div>
                <div className="status-option-text">
                  <strong>Out of Service</strong>
                  <span>Not available for use</span>
                </div>
              </label>
            </div>
          </div>

          {status === 'out_of_service' && (
            <>
              <div className="form-group">
                <label>Reason</label>
                <div className="reason-grid">
                  <label className={`reason-option ${reason === 'mechanical' ? 'selected' : ''}`}>
                    <input
                      type="radio"
                      name="reason"
                      value="mechanical"
                      checked={reason === 'mechanical'}
                      onChange={(e) => setReason(e.target.value)}
                    />
                    <span className="reason-icon">{Icons.wrench}</span>
                    <span className="reason-label">Mechanical</span>
                  </label>
                  <label className={`reason-option ${reason === 'compliance' ? 'selected' : ''}`}>
                    <input
                      type="radio"
                      name="reason"
                      value="compliance"
                      checked={reason === 'compliance'}
                      onChange={(e) => setReason(e.target.value)}
                    />
                    <span className="reason-icon">{Icons.clipboard}</span>
                    <span className="reason-label">Compliance</span>
                  </label>
                  <label className={`reason-option ${reason === 'accident' ? 'selected' : ''}`}>
                    <input
                      type="radio"
                      name="reason"
                      value="accident"
                      checked={reason === 'accident'}
                      onChange={(e) => setReason(e.target.value)}
                    />
                    <span className="reason-icon">{Icons.alert}</span>
                    <span className="reason-label">Accident</span>
                  </label>
                  <label className={`reason-option ${reason === 'other' ? 'selected' : ''}`}>
                    <input
                      type="radio"
                      name="reason"
                      value="other"
                      checked={reason === 'other'}
                      onChange={(e) => setReason(e.target.value)}
                    />
                    <span className="reason-icon">?</span>
                    <span className="reason-label">Other</span>
                  </label>
                </div>
              </div>

              <div className="form-group">
                <label>Details</label>
                <textarea
                  rows={3}
                  value={reasonDetail}
                  onChange={(e) => setReasonDetail(e.target.value)}
                  placeholder="Describe the issue..."
                />
              </div>

              <div className="form-group">
                <label>Expected Return Date</label>
                <input
                  type="date"
                  value={expectedReturn}
                  onChange={(e) => setExpectedReturn(e.target.value)}
                />
              </div>
            </>
          )}

          {vehicle.status === 'out_of_service' && status === 'available' && (
            <div className="form-group">
              <label>Resolution Notes</label>
              <textarea
                rows={3}
                value={resolutionNotes}
                onChange={(e) => setResolutionNotes(e.target.value)}
                placeholder="What was done to resolve the issue?"
              />
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Cancel</button>
          <button 
            className={status === 'available' && vehicle.status === 'out_of_service' ? 'btn-success' : 'btn-primary'}
            onClick={handleSubmit}
            disabled={saving || (status === 'out_of_service' && !reason)}
          >
            {saving ? 'Saving...' : status === 'available' && vehicle.status === 'out_of_service' ? 'Return to Service' : 'Update Status'}
          </button>
        </div>
      </div>
    </div>
  );
};


// ===========================
// VEHICLE DETAIL MODAL
// ===========================
const VehicleDetailModal = ({ vehicle, onClose, onStatusChange, onDispose }) => {
  const [activeTab, setActiveTab] = useState('info');

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content large" onClick={e => e.stopPropagation()}>
        <div className="vehicle-detail-header">
          <div className="vehicle-detail-icon">{Icons.bus}</div>
          <div className="vehicle-detail-info">
            <h2>{vehicle.bus_number}</h2>
            <p>{vehicle.make} {vehicle.model} {vehicle.year}</p>
          </div>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="detail-tabs">
          <button 
            className={`detail-tab ${activeTab === 'info' ? 'active' : ''}`}
            onClick={() => setActiveTab('info')}
          >
            Information
          </button>
          <button 
            className={`detail-tab ${activeTab === 'specs' ? 'active' : ''}`}
            onClick={() => setActiveTab('specs')}
          >
            Specs
          </button>
          <button 
            className={`detail-tab ${activeTab === 'history' ? 'active' : ''}`}
            onClick={() => setActiveTab('history')}
          >
            Status History
          </button>
          <button 
            className={`detail-tab ${activeTab === 'maintenance' ? 'active' : ''}`}
            onClick={() => setActiveTab('maintenance')}
          >
            Maintenance
          </button>
        </div>

        <div className="detail-content">
          {activeTab === 'info' && (
            <>
              <div className="info-grid">
                <div className="info-item">
                  <label>Status</label>
                  <span>
                    {vehicle.status === 'retired' 
                      ? `Retired (${vehicle.disposal_type || 'Unknown'})`
                      : vehicle.status === 'out_of_service' 
                        ? `Out of Service - ${vehicle.out_of_service_reason || 'Unknown'}`
                        : (vehicle.status === 'active' ? 'Available' : vehicle.status?.replace('_', ' '))
                    }
                  </span>
                </div>
                <div className="info-item">
                  <label>VIN</label>
                  <span>{vehicle.vin || '—'}</span>
                </div>
                <div className="info-item">
                  <label>License Plate</label>
                  <span>{vehicle.license_plate || '—'}</span>
                </div>
                <div className="info-item">
                  <label>Capacity</label>
                  <span>{vehicle.capacity} passengers</span>
                </div>
                <div className="info-item">
                  <label>Geotab Device ID</label>
                  <span>{vehicle.geotab_device_id || '—'}</span>
                </div>
                <div className="info-item">
                  <label>Geotab Serial</label>
                  <span>{vehicle.geotab_serial_number || '—'}</span>
                </div>
                <div className="info-item">
                  <label>Current Route</label>
                  <span>{vehicle.route_number || '—'}</span>
                </div>
                <div className="info-item">
                  <label>Assigned Driver</label>
                  <span>{vehicle.assigned_driver_name || '—'}</span>
                </div>
              </div>

              {vehicle.status === 'out_of_service' && (
                <div style={{ marginTop: '1.5rem', padding: '1rem', background: 'rgba(239,68,68,0.1)', borderRadius: '8px' }}>
                  <h4 style={{ color: '#F87171', marginBottom: '0.5rem' }}>Out of Service Details</h4>
                  <p><strong>Reason:</strong> {vehicle.out_of_service_reason}</p>
                  {vehicle.out_of_service_notes && (
                    <p><strong>Notes:</strong> {vehicle.out_of_service_notes}</p>
                  )}
                  {vehicle.expected_return_date && (
                    <p><strong>Expected Return:</strong> {new Date(vehicle.expected_return_date).toLocaleDateString()}</p>
                  )}
                  <button 
                    className="btn-success" 
                    style={{ marginTop: '1rem' }}
                    onClick={onStatusChange}
                  >
                    Return to Service
                  </button>
                </div>
              )}

              {vehicle.status === 'retired' && (
                <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#1E1E1E', borderRadius: '8px', border: '1px solid #2A2A2A' }}>
                  <h4 style={{ color: '#A0A0A0', marginBottom: '0.5rem' }}>Disposal Information</h4>
                  <p><strong>Type:</strong> {vehicle.disposal_type || '—'}</p>
                  {vehicle.disposal_date && (
                    <p><strong>Date:</strong> {new Date(vehicle.disposal_date).toLocaleDateString()}</p>
                  )}
                  {vehicle.disposal_notes && (
                    <p><strong>Notes:</strong> {vehicle.disposal_notes}</p>
                  )}
                </div>
              )}
            </>
          )}

          {activeTab === 'specs' && (
            <div className="info-grid">
              <div className="info-item">
                <label>Vehicle Type</label>
                <span>{vehicle.vehicle_type?.replace('_', ' ') || '—'}</span>
              </div>
              <div className="info-item">
                <label>Fuel Type</label>
                <span>{vehicle.fuel_type || '—'}</span>
              </div>
              <div className="info-item">
                <label>Engine Type</label>
                <span>{vehicle.engine_type || '—'}</span>
              </div>
              <div className="info-item">
                <label>Transmission</label>
                <span>{vehicle.transmission || '—'}</span>
              </div>
              <div className="info-item">
                <label>GVWR</label>
                <span>{vehicle.gvwr ? `${vehicle.gvwr} lbs` : '—'}</span>
              </div>
              <div className="info-item">
                <label>Wheelbase</label>
                <span>{vehicle.wheelbase || '—'}</span>
              </div>
              <div className="info-item">
                <label>Brake Type</label>
                <span>{vehicle.brake_type || '—'}</span>
              </div>
              <div className="info-item">
                <label>AC Equipped</label>
                <span>{vehicle.ac_equipped != null ? (vehicle.ac_equipped ? 'Yes' : 'No') : '—'}</span>
              </div>
              <div className="info-item">
                <label>Wheelchair Lift</label>
                <span>{vehicle.wheelchair_lift != null ? (vehicle.wheelchair_lift ? 'Yes' : 'No') : '—'}</span>
              </div>
              <div className="info-item">
                <label>GPS Equipped</label>
                <span>{vehicle.gps_equipped != null ? (vehicle.gps_equipped ? 'Yes' : 'No') : '—'}</span>
              </div>
              <div className="info-item">
                <label>Camera System</label>
                <span>{vehicle.camera_system != null ? (vehicle.camera_system ? 'Yes' : 'No') : '—'}</span>
              </div>
              <div className="info-item">
                <label>Odometer</label>
                <span>{vehicle.odometer_reading ? `${Number(vehicle.odometer_reading).toLocaleString()} mi` : '—'}</span>
              </div>
              <div className="info-item">
                <label>Inspection Expiry</label>
                <span>{vehicle.inspection_expiry ? new Date(vehicle.inspection_expiry).toLocaleDateString() : '—'}</span>
              </div>
              <div className="info-item">
                <label>Registration Expiry</label>
                <span>{vehicle.registration_expiry ? new Date(vehicle.registration_expiry).toLocaleDateString() : '—'}</span>
              </div>
              <div className="info-item">
                <label>Insurance Expiry</label>
                <span>{vehicle.insurance_expiry ? new Date(vehicle.insurance_expiry).toLocaleDateString() : '—'}</span>
              </div>
              <div className="info-item">
                <label>Purchase Date</label>
                <span>{vehicle.purchase_date ? new Date(vehicle.purchase_date).toLocaleDateString() : '—'}</span>
              </div>
            </div>
          )}

          {activeTab === 'history' && (
            <div className="status-history">
              {vehicle.status_history && vehicle.status_history.length > 0 ? (
                vehicle.status_history.map((log, idx) => (
                  <div key={idx} className="history-item">
                    <div className={`history-icon ${log.new_status === 'out_of_service' ? 'out' : 'available'}`}>
                      {log.new_status === 'out_of_service' ? Icons.alert : Icons.check}
                    </div>
                    <div className="history-content">
                      <div className="history-title">
                        {log.previous_status?.replace('_', ' ')} → {log.new_status.replace('_', ' ')}
                        {log.reason && ` (${log.reason})`}
                      </div>
                      <div className="history-meta">
                        {log.reported_by_name} • {new Date(log.created_at).toLocaleDateString()}
                      </div>
                      {log.reason_detail && (
                        <div className="history-duration">{log.reason_detail}</div>
                      )}
                      {log.resolved_at && (
                        <div className="history-duration" style={{ color: '#4ADE80' }}>
                          ✓ Resolved by {log.resolved_by_name} on {new Date(log.resolved_at).toLocaleDateString()}
                        </div>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <p style={{ color: '#6B6B6B', textAlign: 'center' }}>No status history available</p>
              )}
            </div>
          )}

          {activeTab === 'maintenance' && (
            <div>
              {vehicle.maintenance_history && vehicle.maintenance_history.length > 0 ? (
                vehicle.maintenance_history.map((record, idx) => (
                  <div key={idx} className="history-item">
                    <div className="history-icon" style={{ background: 'rgba(212,169,78,0.1)', color: '#D4A94E' }}>{Icons.wrench}</div>
                    <div className="history-content">
                      <div className="history-title">{record.maintenance_type}</div>
                      <div className="history-meta">
                        {new Date(record.maintenance_date).toLocaleDateString()}
                        {record.cost && ` • $${record.cost}`}
                      </div>
                      {record.description && (
                        <div className="history-duration">{record.description}</div>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <p style={{ color: '#6B6B6B', textAlign: 'center' }}>No maintenance records</p>
              )}
            </div>
          )}
        </div>

        <div className="modal-footer">
          {vehicle.status !== 'retired' && (
            <>
              <button className="btn-primary" onClick={onStatusChange}>Change Status</button>
              <button className="btn-danger" onClick={onDispose}>Dispose</button>
            </>
          )}
          <button className="btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default Fleet;
